export default __webpack_public_path__ + "a7ef8bd71ce2a73f54ff60a9c263fb9a.png";